import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { DevExtremeModule, DxDataGridComponent, DxListComponent } from 'devextreme-angular';
import { alert } from 'devextreme/ui/dialog';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AppInformationService } from '../../core/app-information.service';
import { ArkUnitOfWork } from '../../core/core.module';

@Component({
    selector: 'app-input-dialog',
    templateUrl: './input-dialog.component.html',
    styleUrls: ['./input-dialog.component.scss'],
    standalone: true,
    imports: [DevExtremeModule, DxListComponent],
})
export class InputDialogComponent implements OnInit, AfterViewInit {
    result: Subject<any> = new Subject<any>();
    dialogHeader: string;
    dialogPrompt: string;
    dialogMessage: string;
    dialogValue: any;
    dialogValueArray: any[];
    defaultValue: any;
    checkNumeric: boolean;
    checkInteger: boolean;
    minValue: number = null;
    mode = 'text';
    saveAndNewVisible = false;
    autoSaveIfNotEmpty = false;
    autoSaveInterval: any;
    previousValue: any;
    listSelectMode: string;

    storageKey: string;
    dataSource: any;

    @ViewChild('inputComponent') inputComponent: any;
    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    @ViewChild('selectList') selectList: DxListComponent;

    constructor(
        public modalRef: BsModalRef,
        private uow: ArkUnitOfWork,
        private appInfo: AppInformationService
    ) {}

    async ngOnInit() {}

    checkInput() {
        if (
            this.dialogValue !== undefined &&
            this.dialogValue.length > 0 &&
            this.dialogValue !== this.previousValue
        ) {
            this.previousValue = this.dialogValue;
        } else if (
            this.dialogValue !== undefined &&
            this.dialogValue.length > 0 &&
            this.dialogValue === this.previousValue
        ) {
            clearInterval(this.autoSaveInterval);
            this.save();
        }
    }

    ngAfterViewInit() {
        if (this.mode !== 'dataGrid' && this.mode !== 'list')
            setTimeout(() => {
                this.inputComponent?.instance?.focus();
            });

        if (this.autoSaveIfNotEmpty) {
            this.autoSaveInterval = setInterval(() => {
                this.checkInput();
            }, 500);
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'before',
            },
            {
                location: 'before',
                template: 'toolbarButtons',
            }
        );
    }

    onInput(e) {}

    enterPressed() {
        if (this.mode !== 'textarea') this.save();
    }

    save(andNew?: boolean) {
        if (this.checkNumeric && isNaN(this.dialogValue)) {
            alert(
                'Value needs to be a number',
                `${this.appInfo.settings.church.toUpperCase()} CHURCH`
            );
            return;
        }
        if (
            this.checkInteger &&
            (isNaN(this.dialogValue) ||
                Number(this.dialogValue) !==
                    Math.round(Number(this.dialogValue)))
        ) {
            alert(
                'Value needs to be an integer',
                `${this.appInfo.settings.church.toUpperCase()} CHURCH`
            );
            return;
        }
        if (
            this.minValue != null &&
            Number(this.dialogValue) < Number(this.minValue)
        ) {
            alert(
                `Value needs to be greater than or equal to ${this.minValue}`,
                `${this.appInfo.settings.church.toUpperCase()} CHURCH`
            );
            return;
        }
        if (andNew) {
            //
        } else {
            if (this.mode === 'list') {
                const selectedItems = this.selectList.selectedItems;
                this.result.next({ success: true, value: selectedItems });
            } else
            this.result.next({ success: true, value: this.dialogValue });
        }
    }

    cancel() {
        this.result.next({ success: false });
    }
}
